// extracted by css-extract-rspack-plugin
export default {"exception":"exception_cdT0i","error":"error_GBF0c","errorImg":"error-img_bLSXI","errorCode":"error-code_rA7et","errorMessage":"error-message_TAxcB"};